import { cva } from "class-variance-authority";

export const inputVariants = cva(
	"flex w-full rounded-md border border-primary-600 bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
	{
		variants: {
			variant: {
				green:
					"w-full text-base font-medium placeholder-transparent border peer border-primary-500 rounded-2xl text-textDark focus:outline-none focus:border-2 focus:border-primary-600",
			},
			size: {
				default: "h-9",
				sm: "h-8",
				lg: "h-14",
			},
			fontWeight: {
				bold: "font-bold",
			},
		},
		defaultVariants: {
			size: "default",
		},
	},
);
